"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var exceptions = {
    nullSecretKey: 'NO SECRET KEY DEFINED. YOU NEED TO DEFINED A SECRET KEY IN ORDER TO SUCCESSFULLY ENCRYPT OR DECRYPT DATA.',
    nullKey: 'NO STORAGE ITEM KEY DEFINED. UNABLE TO IDENTIFY STORAGE ITEM TO RETRIEVE',
    retrievingUndecryptedItem: 'TRYING TO RETRIEVE ENCRYPTED ITEM WITH INVALD OR UNSPECIFIED DECRYPTION CODE',
    indexedDB: {
        unsupported: 'THIS BROWSER DOES NOT YET SUPPORT THE INDEXEDDB SPECIFICATION OR IT IS IMPROPERLY SPECIFED'
    }
};
exports.default = exceptions;
